import React from 'react';

const ForwarSvg = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='14'
      viewBox='0 0 18 14'
      fill='none'
      {...props}
    >
      <path
        d='M9.8125 13.7725C10.0156 13.7725 10.2083 13.7334 10.3906 13.6553C10.5781 13.5818 10.7734 13.4601 10.9766 13.2901L17.1641 8.16313C17.3151 8.03909 17.4219 7.90587 17.4844 7.76345C17.5521 7.62104 17.5859 7.48781 17.5859 7.36377C17.5859 7.23514 17.5521 7.10191 17.4844 6.96409C17.4219 6.82167 17.3151 6.68845 17.1641 6.56441L10.9766 1.4788C10.7526 1.29044 10.5547 1.15722 10.3828 1.07912C10.2161 0.996425 10.0286 0.955078 9.82031 0.955078C9.51302 0.955078 9.25781 1.04926 9.05469 1.23761C8.85677 1.42137 8.75781 1.64418 8.75781 1.90605V4.37305H8.5625C7.20833 4.37305 6.03385 4.55911 5.03906 4.93122C4.04948 5.29875 3.22917 5.83395 2.57812 6.53684C1.93229 7.23973 1.45052 8.08963 1.13281 9.08654C0.815104 10.0788 0.65625 11.1998 0.65625 12.4494C0.65625 12.8766 0.747396 13.1982 0.929688 13.4141C1.11719 13.6346 1.34635 13.7449 1.61719 13.7449C1.82031 13.7449 2.01302 13.7058 2.19531 13.6277C2.38281 13.5497 2.55208 13.3866 2.70312 13.1385C3.11458 12.4586 3.59375 11.9165 4.14062 11.5122C4.6875 11.1079 5.32292 10.8162 6.04688 10.637C6.77083 10.4579 7.60938 10.3683 8.5625 10.3683H8.75781V12.8559C8.75781 13.1178 8.85677 13.336 9.05469 13.5106C9.25781 13.6852 9.51042 13.7725 9.8125 13.7725Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default ForwarSvg;
